<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<Header @custom-event="getToken"></Header>
		
		<div class="page_content">			
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/tw/">首頁</a><span class="space">/</span><a href="/tw/user/index">我的帳戶</a><span class="space">/</span>重設密碼
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->			
		</div>
		
		<div class="pub_div new_user_center_box">
			
			<!--左侧菜单-开始-->
			<UserLeftPannel :fileName="'reset_password'" :Token="this.token"></UserLeftPannel>
			<!--左侧菜单-结束-->
			
			<!--右侧内容-开始-->
			<div class="right_content_box">
				<h1>重設密碼</h1>
				
				<div class="user_main_box">					
					<div class="items_box">
						<div class="item">
							<ul>
								<li>
									<h5>原密碼</h5>
									<el-input
									  placeholder="請輸入原密碼（必填）"
									  v-model="oldPassword"
									  maxlength="20"
									  type="password"
									  ref="oldPassword"
									  clearable>
									</el-input>
								</li>
								<li>
									<h5>新密碼</h5>
									<el-input
									  placeholder="請輸入新密碼（必填）"
									  v-model="newPassword"
									  maxlength="20"
									  type="password"
									  ref="newPassword"
									  clearable>
									</el-input>
								</li>
								<li>
									<h5>確認新密碼</h5>
									<el-input
									  placeholder="請再次輸入新密碼（必填）"
									  v-model="reNewPassword"
									  maxlength="20"
									  type="password"
									  ref="reNewPassword"
									  clearable>
									</el-input>
								</li>
							</ul>
						</div>
					</div>
					
					<div class="btns">
						<el-button type="primary" round :loading="btnLoading" @click="resetPassword()">{{btnTxt}}</el-button>
						<el-button round plain onclick="location.href='index'">取消</el-button>
					</div>
					
				</div>
			</div>
			<!--右侧内容-结束-->
			
		</div>
		
		<Footer></Footer>
	</div>
</template>


<script>
	import {
		checkToken,
		userChangePassword,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import Header from '@/components/tw_header.vue'
	import Footer from '@/components/tw_footer.vue'
	import UserLeftPannel from '@/components/tw_user_left_pannel.vue'
	export default {
		name: 'TW_UserIndex',
		mixins: [mixin],
		components: {
			Header,
			Footer,
			UserLeftPannel,
		},
		data() {
			return {
				fullscreenLoading: false, //loading状态
				language: 'tw', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				
				oldPassword:'',
				newPassword:'',
				reNewPassword:'',
				timer: null,
				
				btnLoading: false,
				btnTxt: '確定',
			}
		},
		created() {
		},
		beforeDestroy() {
			clearTimeout(this.timer)
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
				}
				else				
				{
					this.$router.push({
						path: '/tw/user/login'
					})
				}
			},
			//提交
			async resetPassword() {
				if(this.btnLoading)
				{
					return
				}
				
				if(this.oldPassword == '')
				{
					this.$message.error('請輸入原密碼');
					this.$refs.oldPassword.focus()
					return
				}
				
				if(this.newPassword == '')
				{
					this.$message.error('請輸入新密碼');
					this.$refs.newPassword.focus()
					return
				}
				if(this.newPassword.length<6)
				{
					this.$message.error('新密碼長度不得小於6個字元');
					this.$refs.newPassword.focus()
					return
				}
				
				if(this.newPassword == this.oldPassword)
				{
					this.$message.error('新密碼不能與原密碼一致，請重新輸入');
					this.$refs.newPassword.focus()
					return
				}
				
				if(this.reNewPassword == '')
				{
					this.$message.error('請再次輸入新密碼');
					this.$refs.reNewPassword.focus()
					return
				}
				if(this.reNewPassword != this.newPassword)
				{
					this.$message.error('兩次輸入密碼不一致，請重新輸入');
					this.$refs.reNewPassword.focus()
					return
				}
				
				this.btnLoading = true
				this.btnTxt = "保存中"
				this.fullscreenLoading = true
				
				//组装请求数据
				let postData = {
					NewPassword: this.newPassword,
					OldPassword: this.oldPassword,
				}
				let params={
					Language: this.language,
					Token: this.token,
					Terminal: this.terminal,
					PostData: postData
				}
				
				const { data: res } = await userChangePassword(params)
				if (res.errcode === 0) {
					this.$message.success('密碼重置成功，請重新登錄');					
					this.timer = setTimeout(() => {
						this.$router.push({
							path: '/tw/user/login'
						})
					}, 1000)
				} else {
					this.btnLoading = false
					this.btnTxt = "確定"	
					this.fullscreenLoading = false
					this.$message.error(res.errmsg);
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.user_main_box {
		box-sizing: border-box;
		
		.items_box {
			display: flex;
			box-sizing: border-box;
			
			.item {
				
				h2 {
					font-size: 22px;
					font-weight: 500;
				}
				
				ul {
					
					li {
						margin-top: 40px;
						
						h5 {
							font-size: 15px;
							font-weight: 400;
							margin-bottom: 10px;
						}
						
						.elem {
							display: flex;
							justify-content: space-between;
							
							.address {
								width: 70%;
							}
							.zipcode {
								width: 26%;
							}
						}
					}
					li:first-child {
						margin-top: 0;
					}
				}
			}
		}
		
		.btns {
			margin-top: 40px;
			display: flex;
			box-sizing: border-box;
			
			.btn {
				width: 130px;
				font-size: 15px;
				height: 40px;
				line-height: 40px;
				box-sizing: border-box;
				padding: 0 20px;
				border: #008768 solid 1px;
				border-radius: 20px;
				color: #008768;
				cursor: pointer;
				-webkit-transition: all .3s ease;
				margin-right: 20px;
				text-align: center;
			}
			.save {
				background-color: #008768;
				border: #008768 solid 1px;
				color: #fff;				
			}
			.save:hover {
				background-color: #000;
				border: #000 solid 1px;
				color: #fff;	
			}
			.cancle {
				background-color: #fff;
				border: #666 solid 1px;
				color: #666;				
			}
			.cancle:hover {
				border: #008768 solid 1px;
				color: #008768;	
			}
		}
	}
	.el-select {
		width: 100%;
	}
	
	/*输入框*/
	.el-input {
		width: 100%;
		border: #C4C4C4 solid 1px;
		border-radius: 5px;
		background-color: #fff;
		background-image: none;
		font-size: 15px;
		color: #000;
	}
	/deep/ .el-input__inner {
		width: 450px;
		background-image: none;
		font-weight: 400;
	}
	
	/*按钮*/
	.el-button {
		width: 130px;
		font-family: "PingFang SC", sans-serif, Helvetica, Arial;
		font-size: 15px;
		font-weight: 400;
		height: 42px;
		border-radius: 21px;
	}
	.el-button--default {
		border: #3D7856 solid 1px;
		color: #3D7856;
		margin-left: 20px;
		border-radius: 8px;
	}
	.el-button--default:hover {
		border: #3D7856 solid 2px;
		color: #3D7856;
	}
	.el-button.is-plain:focus  {
		border: #3D7856 solid 1px;
		color: #3D7856;
	}
	
	.el-button--primary {
		border: 0;
		border-radius: 8px;
	}		
	.el-button--primary:focus {
		background-color: #3D7856;
	}
	.el-button--primary:hover {
		background-color: #000;
	}
	
</style>